export default "__VITE_ASSET__BlDLwTN7__"